const user = {
    id: 0,
    name: '',
    permissions: {
        public: true
    },
    info: {
        email_invoice: '',
        adr1:          '',
        adr2:          '',
        adr3:          '',
        postcode:      '',
        city:          '',
        country:       '',
        phone:         '',
        vat_number:    ''
    }
};

export function getUserFromLoginObject(data){
    user.id = data.userid;
    user.name = data.name;
    user.permissions = formatPermissions(data.permissions);

    return user
}

export function formatPermissions(permissions){
    let result = {};
    for (let perm of Object.keys(permissions))
    {
        if(permissions[perm] === true) // Sanitize
        {
            let name = perm.split(".").join("_");
            name = name.split("-").join("_");
            result[name] = true;
        }
    }
    return result;
}

export default user


// WEBPACK FOOTER //
// ./src/user.js